import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { EditAttrezzaturaComponent } from '../modals/edit-attrezzatura/edit-attrezzatura.component';
import { EditDipendentiComponent } from '../modals/edit-dipendenti/edit-dipendenti.component';
import { AttAttrezzatura } from '../objects/AttAttrezzatura';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { SnackbarService } from '../services/snackbar.service';

@Component({
  selector: 'app-attrezzatura',
  templateUrl: './attrezzatura.component.html',
  styleUrls: ['./attrezzatura.component.scss']
})
export class AttrezzaturaComponent implements OnInit {

  users: AttAttrezzatura[] = [];

  displayedColumns: string[] = ['email', 'password', 'enable', 'actions'];
  dataSource;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private loadingService: LoadingService,
    private apiService: ApiService,
    private dialog: MatDialog,
    private snackBarService: SnackbarService
  ) {
    this.loadingService.showLoading();
    this.getAllUsers();
   }

  ngOnInit(): void {
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getAllUsers() {
    this.apiService.getAllAttrezzatura()
    .then((users: AttAttrezzatura[]) => {
      console.log(users)
      this.loadingService.hideLoading();
      this.dataSource = new MatTableDataSource(users);
      this.dataSource.paginator = this.paginator;      
    })
  }

  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.users);
    this.dataSource.paginator = this.paginator;
  }

  addElement() {
    let user: AttAttrezzatura = new AttAttrezzatura();
    const dialogRef = this.dialog.open(EditAttrezzaturaComponent, {
      width: '80%',
      // data: {name: this.name, animal: this.animal}
      data: user
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAllUsers();
    });
  }

  editElement(user: AttAttrezzatura){
    const dialogRef = this.dialog.open(EditAttrezzaturaComponent, {
      width: '80%',
      // data: {name: this.name, animal: this.animal}
      data: user
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAllUsers();
    });
  }

  deleteElement(user: AttAttrezzatura){
    if(confirm('Sei sicuro? Azione irreversibile, le missioni di questo utente saranno resettate')){
      this.loadingService.showLoading();
      this.apiService.deleteAttrezzatura(user)
      .then(x => {
        if(x){
          this.getAllUsers();
          this.snackBarService.openSnackBar("Operazione eseguita con successo")
        } else {
          this.snackBarService.openSnackBar("Ops, qualcosa è andato storto si prega di riprovare")
        }
        this.loadingService.hideLoading();
      })
    }
  }

}
